export default __webpack_public_path__ + "static/media/cliente.92dcf894.svg";